<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("update_organization") }}</template>
		</core-layout-headline-and-actions>

		<!-- Update Form -->
		<j-card class="xs-12 bg5 r2 p4">
			<create-update-form :data="form" @input="handleSubmit">
				<div class="mt6" slot="actions" slot-scope="{ onSubmit }">
					<j-button
						:isLoading="isLoading"
						@click="onSubmit"
					>{{ $t("update_organization") }}</j-button>
				</div>
			</create-update-form>
		</j-card>

		<!-- Delete -->
		<div class="flex xs-12 xs-right bt1 bc7 pt2 mt8">
			<j-button
				type="error"
				v-can="'writeOrganizations'"
				@click="$modal.show('j-dialog')"
				:isLoading="isDeleteLoading"
			>{{ $t("delete_organization") }}</j-button>
		</div>

		<!-- Delete confirmation modal -->
		<j-dialog
			:height="200"
			:width="600"
			:title="$t('delete')"
			type="delete"
			@confirm="removeOrganization"
		>{{ $t("errors.are_you_sure_you_want_to_delete_organization") }}</j-dialog>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CreateUpdateForm from "../components/CreateUpdateForm"
import JDialog from "@/components/JDialog/"
import api from "../api/"

export default {
	components: {
		JCard,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CreateUpdateForm,
		JDialog
	},

	props: {
		id: { type: String, required: true }
	},

	data: () => ({
		isLoading: false,

		form: {
			name: null,
			source: null,
			photoUrl: null,
			isActive: true
		},

		isDeleteLoading: false
	}),

	methods: {
		async handleSubmit(payload) {
			this.isLoading = true

			// Prepare input
			const updateOrganizationInput = {
				nameFormat: payload.name,
				isActive: payload.isActive,
				photoUrl: payload.photoUrl,
				source: payload.source
			}

			const res = await api.updateOrganization({
				id: this.id,
				updateOrganizationInput
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Redirect to detail
			this.$router.push({
				name: "OrganizationsList"
			})
		},

		async fetchOrganization() {
			this.isLoading = true
			const res = await api.organization({
				where: { id: this.id }
			})
			this.isLoading = false

			if (res.errors) {
				this.$router.push({ name: "OrganizationsList" })
				return
			}

			if (!res.data.organizations.list[0]) {
				this.$router.push({ name: "OrganizationsList" })
				return
			}

			// Success
			const {
				name,
				source,
				photoUrl,
				isActive
			} = res.data.organizations.list[0]

			this.form = {
				name,
				source,
				photoUrl,
				isActive
			}
		},

		async removeOrganization() {
			this.isDeleteLoading = true

			const res = await api.deleteOrganization({ id: this.id })
			this.isDeleteLoading = false

			this.$modal.hide("j-dialog")

			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("organization_deleted")
					}
				})

			this.fetchOrganization()
		}
	},

	mounted() {
		this.fetchOrganization()
	}
}
</script>
